import { env } from '@/lib/runtime-env'

export type FirebasePublicConfig = {
  apiKey?: string
  authDomain?: string
  projectId?: string
  storageBucket?: string
  messagingSenderId?: string
  appId?: string
  measurementId?: string
}

export const getFirebasePublicConfig = (): FirebasePublicConfig => {
  return {
    apiKey: 'AIzaSyB0nsGTsZzrHDtcdryjENRkXEWaGU2hifQ',
    authDomain: 'viverse-mobile.firebaseapp.com',
    projectId: 'viverse-mobile',
    storageBucket: 'viverse-mobile.firebasestorage.app',
    messagingSenderId: '725970460736',
    appId: '1:725970460736:web:f2224da89d0e7ecb627fa5',
    measurementId: env('NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID') || 'G-GZ9YEMT6BD',
  }
}
